// extracted by mini-css-extract-plugin
export default {"tab-view-grid":"StatsTable_tab-view-grid__JD6Py","tab-view":"StatsTable_tab-view__GXMYR","stickyItem":"StatsTable_stickyItem__B5qWN","selectorRow":"StatsTable_selectorRow__31ppS"};